export default __webpack_public_path__ + "static/media/Neddie-Screen-6.59e46596.png";